/**
 * @generated SignedSource<<81e93a694d2571e2af898a5ef78f9a4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpecialDealsQuery$variables = {};
export type SpecialDealsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SpecialDeals_highlightDeals" | "SpecialDeals_matchForCompanyDeals">;
};
export type SpecialDealsQuery = {
  response: SpecialDealsQuery$data;
  variables: SpecialDealsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v1 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "-date"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentChange",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "releaseType",
    "storageKey": null
  },
  (v2/*: any*/),
  (v6/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeaturedDealNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeaturedDealNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "watching",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "editorialNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TikTokSoundNodeConnection",
            "kind": "LinkedField",
            "name": "tiktokSounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TikTokSoundNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokSoundNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tiktokUrl",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatWithDelta",
                        "kind": "LinkedField",
                        "name": "mostRecentStat",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "previous",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatWithDelta",
                "kind": "LinkedField",
                "name": "latestSpotifyMonthlyListenerCount",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "spotifyProfile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastActiveAt",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWatchingCurrentUserCompany",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActorInterface"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "soundLink",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "releases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "unreleasedReleases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "OfferFeaturedDealInterface",
            "abstractKey": "__isOfferFeaturedDealInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SpecialDealsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SpecialDeals_matchForCompanyDeals"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SpecialDeals_highlightDeals"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SpecialDealsQuery",
    "selections": [
      {
        "alias": "matchForCompanyDeals",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "isMatchDismissed",
            "value": false
          },
          {
            "kind": "Literal",
            "name": "isMatchForCompany",
            "value": true
          },
          (v1/*: any*/)
        ],
        "concreteType": "FeaturedDealNodeConnection",
        "kind": "LinkedField",
        "name": "availableFeaturedDeals",
        "plural": false,
        "selections": (v8/*: any*/),
        "storageKey": "availableFeaturedDeals(first:3,isMatchDismissed:false,isMatchForCompany:true,orderBy:\"-date\")"
      },
      {
        "alias": "highlightDeals",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "isHighlight",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "isMatchForCompany",
            "value": false
          },
          (v1/*: any*/)
        ],
        "concreteType": "FeaturedDealNodeConnection",
        "kind": "LinkedField",
        "name": "availableFeaturedDeals",
        "plural": false,
        "selections": (v8/*: any*/),
        "storageKey": "availableFeaturedDeals(first:3,isHighlight:true,isMatchForCompany:false,orderBy:\"-date\")"
      }
    ]
  },
  "params": {
    "cacheID": "36ae54fe5cd17046170414e8cd992706",
    "id": null,
    "metadata": {},
    "name": "SpecialDealsQuery",
    "operationKind": "query",
    "text": "query SpecialDealsQuery {\n  ...SpecialDeals_matchForCompanyDeals\n  ...SpecialDeals_highlightDeals\n}\n\nfragment ReleaseIconsNames_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  ...ReleaseIconsNames_releaseImages\n  ...useFeaturedDealTitle\n}\n\nfragment ReleaseIconsNames_releaseImages on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment RowDeal_dropdown on FeaturedDealNode {\n  id\n  watching\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n  artist {\n    ...useMessage_actor\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    id\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment RowDeal_useTikTokSoundsTotal on TikTokSoundNodeConnection {\n  edges {\n    node {\n      tiktokUrl\n      name\n      mostRecentStat {\n        current\n        previous\n        percentChange\n      }\n      id\n    }\n  }\n}\n\nfragment SpecialDeal_featuredDeal on FeaturedDealNode {\n  ...RowDeal_dropdown\n  id\n  soundLink\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n  artist {\n    ...useMessage_actor\n    ...useArtistThumbnailUrl_artist\n    user {\n      lastActiveAt\n      id\n    }\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    isWatchingCurrentUserCompany\n    spotifyProfile {\n      url\n      id\n    }\n    id\n  }\n  ...ReleaseIconsNames_query\n}\n\nfragment SpecialDeals_highlightDeals on Query {\n  highlightDeals: availableFeaturedDeals(isMatchForCompany: false, isHighlight: true, first: 3, orderBy: \"-date\") {\n    edges {\n      node {\n        id\n        ...SpecialDeal_featuredDeal\n      }\n    }\n  }\n}\n\nfragment SpecialDeals_matchForCompanyDeals on Query {\n  matchForCompanyDeals: availableFeaturedDeals(isMatchForCompany: true, isMatchDismissed: false, first: 3, orderBy: \"-date\") {\n    edges {\n      node {\n        id\n        ...SpecialDeal_featuredDeal\n      }\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n"
  }
};
})();

(node as any).hash = "77160d06a1be08f20ef47c950ea5ccfe";

export default node;
